import React from "react";

function DocumentsVerificationIcon() {
  return (
    <svg
      width="16"
      height="18"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.59375 1.6875H2.21875C1.753 1.6875 1.375 2.0655 1.375 2.53125V15.4688C1.375 15.9345 1.753 16.3125 2.21875 16.3125H11.7812C12.247 16.3125 12.625 15.9345 12.625 15.4688V8.71875M5.59375 1.6875H5.875C7.66521 1.6875 9.3821 2.39866 10.648 3.66453C11.9138 4.9304 12.625 6.64729 12.625 8.4375V8.71875M5.59375 1.6875C6.26508 1.6875 6.90891 1.95418 7.38361 2.42889C7.85832 2.90359 8.125 3.54742 8.125 4.21875V5.34375C8.125 5.8095 8.503 6.1875 8.96875 6.1875H10.0938C10.7651 6.1875 11.4089 6.45418 11.8836 6.92889C12.3583 7.40359 12.625 8.04742 12.625 8.71875M4.75 11.25L6.4375 12.9375L9.25 9"
        stroke="#424242"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default DocumentsVerificationIcon;
